export default {
  History: 'History',
  Load_More: 'Load More',
  Transactions: 'Transactions',
  Activity: 'Activity',
  View_Entire_History: 'View Entire History',
  Empty: 'Completed transactions will show here.',
};
